// ─────────────────────────────────────────────────────────────────────────────
// Meta Pixel custom events — theme context (mirrors custom-ga-events.js).
// On the PDP, window.__includMeta.audience holds the event name to fire
// ('apparel' | 'non_apparel'), set by the PDP section from the template suffix.
// ─────────────────────────────────────────────────────────────────────────────

var META_PIXEL_ID = '1398348000640458';

// ── 1. Init Meta Pixel SDK (once per page) ───────────────────────────────────
!(function (f, b, e, v, n, t, s) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

fbq('init', META_PIXEL_ID);
fbq('track', 'PageView');

// ── 2. PDP audience event — fires 'apparel' or 'non_apparel', no params ──────
function firePdpAudienceEvent() {
  var meta = window.__includMeta;
  if (!meta || !meta.audience) return;

  fbq('trackCustom', meta.audience);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', firePdpAudienceEvent);
} else {
  firePdpAudienceEvent();
}
